import React, { useContext } from 'react';
import Tooltip from '@dealroadshow/uikit-tooltip';
import IconWarning from '@dealroadshow/uikit-icon/IconWarning';
import { CountryOfBusinessContext } from '@dataroom/country-of-business/CountryOfBusinessContext';
import { useDataroomTenantContext } from '@dataroom/tenant/DataroomTenantContext';
import { usePathname } from '@framework/next/navigation';
import sharedConfig from "@dataroom/config";
import styles from '../datarooms.module.scss';

interface Props {
  restrictedCountryIds?: string[],
}

export const CountryRestrictionTooltip = ({ restrictedCountryIds = [] }: Props) => {
  const context = useContext(CountryOfBusinessContext);
  const { tenant } = useDataroomTenantContext();
  const asPath = usePathname();

  if (!context) return null;

  const { countryId } = context;
  const isRestricted = countryId != null && restrictedCountryIds.includes(countryId);

  if (!isRestricted) return null;

  const setsName = tenant === sharedConfig.researchroom.code ? 'explore_researches' : 'explore_sets';
  const isExploreSetsTab = asPath.startsWith(`/${ tenant }/${ setsName }`);

  const tooltipContent = isExploreSetsTab
    ? 'Request Access restricted due to Country of Business in your profile'
    : 'Access restricted due to Country of Business in your profile';

  return (
    <Tooltip
      className={ styles.tooltipWarningWrapper }
      content={ tooltipContent }
    >
      <IconWarning className={ styles.iconWarning } />
    </Tooltip>
  );
};

export default CountryRestrictionTooltip;
